import { makeRequest } from "@/utils/makeRequest";
import type { AppDispatch } from "..";
import { setCountries } from "../slices/countrySlice";
import { getErrorMessage } from "@/utils/getErrorMessage";

export const fetchCountries = () => async (dispatch: AppDispatch) => {
  try {
    const res = await makeRequest.get("/country");
    dispatch(setCountries(res.data));
  } catch (error) {
    console.log(error);
    getErrorMessage(error);
  }
};
